import { render, staticRenderFns } from "./comfyuiThemeClass.vue?vue&type=template&id=1ec80fc5&scoped=true&"
import script from "./comfyuiThemeClass.vue?vue&type=script&lang=js&"
export * from "./comfyuiThemeClass.vue?vue&type=script&lang=js&"
import style0 from "./comfyuiThemeClass.vue?vue&type=style&index=0&id=1ec80fc5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec80fc5",
  null
  
)

export default component.exports